<main-content [isBackdropOkay]="isBackdropOkay"
  [isListVisible]="isTerminalsListVisible"
  [isEveryoneSelected]="isTerminalSelected"
  [verticalRightShow]="false"
  [useLeftContent]="!isTerminalsListVisible"
  (changeLeftNavbar)="changeTerminalListVisible($event)">
  <div class="routerOutletTemplate">
    <router-outlet></router-outlet>
  </div>
  <div class="listTemplate">
    <terminal-list [showDetails]="false" class="col-12 myEmployeeList"></terminal-list>
  </div>
</main-content>

@if (isBackdropOkay) {
  <div class="modal-backdrop fade show myBackdrop"></div>
}
